/* ==========================================================================
	Image Viewer
	========================================================================== */

var childImage,
    rect,
    childTop,
    childLeft,
    childRight,
    childBottom,
    $imageGridOverlayBG = jQuery("#imageGridOverlayBG"),
    $imageGridOverlay = jQuery("#imageGridOverlay");

jQuery(".js-view-image").click(function (e) {
    e.preventDefault();

    var $this = jQuery(this);

    $imageGridOverlayBG.fadeIn();
    $imageGridOverlay.show();

    childImage = $this.data("full");

    rect = this.getBoundingClientRect();
    childTop = rect.y;
    childLeft = rect.x;
    childRight = width - childLeft - rect.width;
    childBottom = height - childTop - rect.height;

    var theImage = new Image();
    theImage.src = childImage;

    if (theImage.complete) {
        openImageViewer();
    } else {
        theImage.addEventListener("load", openImageViewer);
        theImage.addEventListener("error", function () {
            closeImageViewer();
            $imageGridOverlay.hide().empty();
        });
    }
});

$imageGridOverlay.click(function () {
    closeImageViewer();
});




function openImageViewer() {
    var $newImage = jQuery("<div>");

    $newImage.css({
        position: "fixed",
        opacity: 0,
        top: childTop + "px",
        left: childLeft + "px",
        right: childRight + "px",
        bottom: childBottom + "px",
        "z-index": 100,
        "background-size": "contain",
        "background-image": "url(" + childImage + ")",
        "background-repeat": "no-repeat",
        "background-position": "center center"
    });

    $newImage.appendTo($imageGridOverlay);

    $imageGridOverlay.imagesLoaded({ background: "div" }, function () {
        $newImage.css({ opacity: "1" }).animate(
            {
                left: "20px",
                top: "20px",
                right: "20px",
                bottom: "20px"
            },
            400
        );
    });
}

function closeImageViewer() {
    $imageGridOverlay.find("div").animate(
        {
            top: childTop + "px",
            left: childLeft + "px",
            right: childRight + "px",
            bottom: childBottom + "px"
        },
        300,
        function () {
            $imageGridOverlay.hide().empty();
        }
    );

    $imageGridOverlayBG.fadeOut(100);
}
